import { STORAGE_CONFIG } from "@common/model";
import { getStorage } from "@common/utils";

// 在这一层统一所有项目的token  userInfo
export const ICT_USER_INFO = STORAGE_CONFIG.LOGIN_USER;
export const APPLICATION_KEY = STORAGE_CONFIG.APPLICATION_KEY;
export const STATIC_PREFIX =
  "https://ict-static.obs.cn-east-2.myhuaweicloud.com/image/ict-2c";
export const STATIC_PREFIX_TB =
  "https://ict-static.obs.cn-east-2.myhuaweicloud.com/image/ict-2b";
export const STATIC_PREFIX_TADMIN =
  "https://ict-static.obs.cn-east-2.myhuaweicloud.com/image/ict-admin";
export const DEFAULT_COVER = `${STATIC_PREFIX}/default-cover.png`;
export const DEFAULT_HEADER_PIC = `${STATIC_PREFIX}/header.png`;
// 从loginUser获取
export const ICT_APPLICATION_KEY = getStorage(ICT_USER_INFO)[APPLICATION_KEY];

